import { render, staticRenderFns } from "./AdvertisingContent.vue?vue&type=template&id=09f8cb55&scoped=true&"
import script from "./AdvertisingContent.vue?vue&type=script&lang=js&"
export * from "./AdvertisingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f8cb55",
  null
  
)

export default component.exports